declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export const RESERVATION_URL =
  "https://widget.elyrasystems.com/hallwylska";

export function trackEvent(event: string, params: Record<string, unknown> = {}): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

export function openReservation(source: string, url: string = RESERVATION_URL): void {
  trackEvent("reservation_click", { reservation_source: source });
  window.open(url, "_blank");
}

export const RESERVATION_EMAIL = "reservations@hallwylska.com";

export function openReservationEmail(source: string, subject?: string): void {
  trackEvent("reservation_click", { reservation_source: source });
  const query = subject ? `?subject=${encodeURIComponent(subject)}` : "";
  window.location.href = `mailto:${RESERVATION_EMAIL}${query}`;
}
